import Vue from "vue";
import { mapGetters, mapActions } from "vuex";

Vue.use({
  install(vue) {
    vue.mixin({
      computed: mapGetters(["isLoggedIn", "currentUser"]),
      methods: mapActions(["login", "logout", "changePassword", "can"]),
    });
  },
});
